import { TRootState } from '../@types/redux';

export const selectCollapsed = (state: TRootState) => state.ui.collapsed